import { QueryProvider } from '@/hooks/useQueryClient';
import { AppRouter } from '@/router';

function App() {
  return (
    <QueryProvider>
      <AppRouter />
    </QueryProvider>
  );
}

export default App;
